import { caseInsensitiveGet } from "@/core/object";
import { isNotEmpty } from "@/core/string";
import { AccessRight, anonymousUser, Identity } from "@/shared/domain";

import { parseToken, pi2AuthTokenProvider, tokenProvider } from "./providers";
import { pi2claims, Scope } from "./types";

export const IDENTITY_STORAGE_KEY = "identity";

export const parseIdentity = (
    accessToken: string,
    accessRights: AccessRight[],
    currentBrokerId: string = null,
): Identity => {
    if (!accessToken) {
        return anonymousUser;
    }

    // decode token & create identity
    const tokenPayload = parseToken(accessToken);
    const pi2Claims = caseInsensitiveGet(tokenPayload, "pi2.claims", null);
    return new Identity({
        id: caseInsensitiveGet(pi2Claims, "pp", ""),
        push: caseInsensitiveGet(pi2Claims, "push", ""),
        email: caseInsensitiveGet(pi2Claims, "email", ""),
        name: caseInsensitiveGet(pi2Claims, "fullName", ""),
        language: caseInsensitiveGet(pi2Claims, "language", ""),
        officeId: caseInsensitiveGet(pi2Claims, "officeId", ""),
        itsmeLogin: !!caseInsensitiveGet(pi2Claims, "itsMeClaims", false),
        scope: caseInsensitiveGet(tokenPayload, "scope", ""),
        accessRights,
        accessToken,
        currentBrokerId: currentBrokerId || caseInsensitiveGet(pi2Claims, "officeId", ""),
        policyHolderId: accessRights?.find((accessRight) => accessRight.mainPolicyHolder === true)?.policyHolderId,
        accessControlListId: accessRights?.find((accessRight) => accessRight.mainPolicyHolder === true)
            ?.accessControlListId,
    });
};

export const getClaims = (): pi2claims => {
    const parsedToken = tokenProvider.getParsedToken();
    return caseInsensitiveGet(parsedToken, "pi2.claims", null);
};

export const isExternalLogin = (): boolean => {
    const pi2Claims = getClaims();
    const pi2AuthToken = pi2AuthTokenProvider.getToken();

    return pi2Claims && !pi2AuthToken;
};

export const isPreviewUser = (): boolean => {
    const parsedToken = tokenProvider.getParsedToken();
    const result = !!caseInsensitiveGet(parsedToken, "scope", null);
    return result;
};

export const isABroker = (): boolean => {
    const parsedToken = tokenProvider.getParsedToken();
    const scope = caseInsensitiveGet(parsedToken, "scope", "");
    return isNotEmpty(scope) && (scope === Scope.Color || scope === Scope.Preview);
};
